/* eslint-disable no-console */

function showUpdateButton (registration) {
  let button = document.createElement('button')
  button.style.position = 'fixed'
  button.style.bottom = '15px'
  button.style.left = '25px'
  button.style.backgroundColor = '#03a587'
  button.className = 'btn btn-lg btn-success'
  button.innerHTML = 'New app version available!<br><b>Click here to update!</b>'

  button.addEventListener('click', function () {
    if (!registration.waiting) {
      // Just to ensure registration.waiting is available before
      // calling postMessage()
      return
    }

    button.disabled = true

    registration.waiting.postMessage('skipWaiting')
  })

  document.body.appendChild(button)
}

function onNewServiceWorker (registration, callback) {
  if (registration.waiting) {
    // SW is waiting to activate. Can occur if multiple clients open and
    // one of the clients is refreshed.
    return callback()
  }

  function listenInstalledStateChange () {
    registration.installing.addEventListener('statechange', function (event) {
      if (event.target.state === 'installed') {
        // A new service worker is available, inform the user
        callback()
      }
    })
  }

  if (registration.installing) {
    return listenInstalledStateChange()
  }

  // We are currently controlled so a new SW may be found...
  // Add a listener in case a new SW is found,
  registration.addEventListener('updatefound', listenInstalledStateChange)
}
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/service-worker.js')
      .then(function (registration) {
        // Track updates to the Service Worker.
        if (!navigator.serviceWorker.controller) {
          // The window client isn't currently controlled so it's a new service
          // worker that will activate immediately
          return
        }

        // When the user asks to update the app, we'll need to reload the window
        let preventDevToolsReloadLoop
        navigator.serviceWorker.addEventListener('controllerchange', function (event) {
          // Ensure refresh is only called once.
          // This works around a bug in "force update on reload".
          if (preventDevToolsReloadLoop) return
          preventDevToolsReloadLoop = true
          console.log('Controller loaded')
          window.location.reload()
        })

        onNewServiceWorker(registration, function () {
          showUpdateButton(registration)
        })
      })
  })

  setInterval(function () {
    navigator.serviceWorker.getRegistrations()
      .then(registrationsArray => {
        registrationsArray[0].update()
      })
  }, 60000)
}
